import { Button } from "zudoku/ui/Button"
import { Link } from "zudoku/router"
import { ArrowRight } from "zudoku/icons"

export const Hero = ({ className }) => (
    <section {...{className}}>
        <div className=" mx-auto text-center">
            <h1 className="text-5xl font-bold mb-6 leading-tight">
                <span>Build the future of compliant digital finance, </span>
                <span className="text-primary">faster</span>.
            </h1>
            <p className="text-xl mb-8 max-w-3xl mx-auto leading-relaxed">
                EMTECH's comprehensive regulatory technology platform provides the APIs and infrastructure 
                you need to navigate complex financial regulations, accelerate go-to-market, and maintain 
                ongoing oversight across multiple jurisdictions.
            </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <Button size="lg" asChild>
              <Link to="quickstart" className="flex items-center">
                Get Started
                <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </Button>
          </div>
    </section>
)